import { Check, Users, Baby, School, Heart, GraduationCap, Globe } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const supportGroups = [{
  title: "Children's Programs",
  description: "Building confidence through AI and coding workshops designed for young minds.",
  icon: "Baby"
}, {
  title: "Family Services",
  description: "Practical digital literacy for the whole household to navigate the digital world safely.",
  icon: "Users"
}, {
  title: "School Partnerships",
  description: "Future-ready curriculum support and resources for modern educational environments.",
  icon: "School"
}, {
  title: "Volunteer Opportunities",
  description: "Mentoring the next generation and sharing your professional expertise with us.",
  icon: "Heart"
}, {
  title: "Educator Services",
  description: "Professional development in creative technology and future-focused teaching methods.",
  icon: "GraduationCap"
}, {
  title: "Community Initiatives",
  description: "Inclusive learning programs for local growth, skills, and digital empowerment.",
  icon: "Globe"
}];
const iconMap: Record<string, any> = {
  Baby,
  Users,
  School,
  Heart,
  GraduationCap,
  Globe
};
export default function WhoWeSupport() {
  return <section data-section-id="259325" id="who-we-support" className="bg-background text-foreground py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-primary text-sm font-bold uppercase tracking-widest mb-3 font-serif">
            Who We Support
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold font-serif tracking-tight text-foreground">
            Empowering Every Corner of Our Community
          </h3>
          <div className="mt-4">
            <Link to="#who-we-support" className="text-primary hover:text-primary/80 font-medium transition-colors underline underline-offset-4">
              <span className="sr-only">Link to Who We Support</span>
            </Link>
          </div>
          <p className="mt-4 text-muted-foreground text-lg max-w-2xl mx-auto">
            We create accessible, practical learning opportunities that build confidence and digital capability for everyone.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {supportGroups.map((group, i) => {
          const IconComponent = iconMap[group.icon];
          return <Card key={i} data-index={i} className="bg-card border-border/50 rounded-2xl shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 group">
                <CardHeader className="pb-2">
                  <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    {IconComponent && <IconComponent className="size-6" />}
                  </div>
                  <CardTitle className="text-2xl font-bold font-serif group-hover:text-primary transition-colors">
                    {group.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {group.description}
                  </p>
                  <div className="mt-6 flex items-center gap-2 text-primary font-medium text-sm">
                    <Check className="size-4" />
                    <span>Support Area</span>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}